/** Regelversion 12: Evaluierungen eigener Gesetze (Reiter „Lage“). */
import { useGame, useS } from '../../store/game';
import { Panel } from '../../components/ui';
import { evalOn, sideName, type EvalRes } from '../../engine/eval12';
import { dateLabel, de } from '../../engine/util';

export function EvalPanel() {
  const S: any = useS(); const { dispatch } = useGame();
  if (!evalOn()) return null;
  const list: EvalRes[] = (S.evals || []).slice(-5).reverse(); if (!list.length) return null;
  const txt = (E: EvalRes) => E.k === 'erfolg' ? 'wirkt besser als erwartet' : E.k === 'neben' ? `Nebenwirkung: ${sideName(E.side)}${E.c ? ` (${de(E.c, 1)} Mrd € im Jahr)` : ''}` : 'bleibt hinter den Erwartungen zurück';
  return (
    <Panel title="Evaluierungen" aside={`${(S.evals || []).length} insgesamt`} className="evalbox">
      <span className="sub">Anderthalb Jahre nach voller Wirkung prüfen Fachleute jedes eurer Gesetze. Schwächen und Nebenwirkungen bleiben, bis ein neues Gesetz zum selben Thema in Kraft tritt.</span>
      <ul className="todolist">{list.map((E) => { const busy = !!S.issues[E.iss]?.law; return (
        <li key={E.lid} className={E.k === 'erfolg' || E.fixed != null ? 'up' : 'warn'}><span><b>„{E.t}“</b> {txt(E)} · {dateLabel(E.m)}{E.fixed != null ? ' · nachgebessert' : ''}</span>
          {E.k !== 'erfolg' && E.fixed == null && <div className="todoacts">{busy ? <span className="sub">Ein Gesetz zum Thema ist schon unterwegs.</span> : <button type="button" className="small" onClick={() => dispatch('evalFix' as any, E.lid)}>Nachbessern</button>}</div>}</li>); })}</ul>
    </Panel>
  );
}
